var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[(false)?_c('div',{staticClass:"tabela"}):_c('EmptyResultLaudo',{attrs:{"semLaudoSelecionado":true,"p1":_vm.$t('mensagens.laudos.nenhumLaudoSelecionado'),"p2":_vm.$t('mensagens.laudos.selecioneTipoDeLaudoParaVisualisar')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }